module.exports = __webpack_public_path__ + "static/img/12-5.f8583df.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/english/12-5.png
// module id = kFzP
// module chunks = 15